﻿/* jshint esversion: 6 */

import { default as AppModule } from './app.module.js';

angular.bootstrap(document, [AppModule]);
